import { render, staticRenderFns } from "./newGameClaimed.vue?vue&type=template&id=79890f5b&"
import script from "./newGameClaimed.vue?vue&type=script&lang=js&"
export * from "./newGameClaimed.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./newGameClaimed.vue?vue&type=style&index=1&id=79890f5b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports